<script setup lang="ts">
import type { PropType } from 'vue'
import type { StopBus } from '~/types'
const props = defineProps({
  pending: {
    type: Boolean,
    default: false,
  },
  departures: {
    type: Array as PropType<StopBus[]>,
    required: true,
  },
})
</script>

<template>
  <div class="departure-list">
    <SkeletonTable v-if="pending" />
    <div
      v-else-if="!pending && !departures?.length"
      class="text-vmcv-gray-darker text-center py-8"
    >
      {{ 'Aucun départ prévu de cet arrêt pour l’instant' }}
    </div>
    <ul v-else>
      <li v-for="(departure, key) in departures" :key="`departure-list-${key}`">
        <DepartureCard :departure="departure" />
      </li>
    </ul>
    <div
      class="flex flex-col space-y-6 sm:flex-row sm:space-y-0 justify-between border-t border-t-vmcv-gray-dark py-8"
    >
      <NuxtLink class="text-vmcv-gray-darker underline" to="/">
        Voir tous les arrêts
      </NuxtLink>
      <div>
        <span class="text-vmcv-blue font-semibold">~ </span>
        <span class="text-vmcv-gray-darker">: Horaire théorique</span>
      </div>
    </div>
  </div>
</template>
